
export class Actor {
  constructor(public name?: string,
              public email?: string) {
  }
}
